export default __webpack_public_path__ + "static/media/Audi_Inside.81b451c8.jpg";